module.exports = __webpack_public_path__ + "media/images/spree/frontend/credit_cards/icons/egold-007139912d6755e63e4cf579dfee2c0c.png";